
import { Component, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { eRechargeType, eType, iPromoteCode, iPromoteQuery } from '@/interface/promote-code';
import { getOldPromoteCodeList, updateOpen } from '@/api/promote-code';
import LogUtils from 'panda-log';
import Edit from '@/views/marketing/promote-code/components/old_edit.vue';
import { toast } from '@/utils/common';
import moment from 'moment';
@Component({
  components: { Edit },
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class ExchangeCode extends Mixins(PageQuery) {
  private visible = false;
  private loading = false;
  private title = '创建推广码';
  private tableData: iPromoteCode[] = [];
  private coin: eType = eType.COIN;
  private weekcard: eType = eType.WEEKCARD;
  private cash: eType = eType.CASH;
  private noLimit: eRechargeType = eRechargeType.NOLIMIT;
  private model: iPromoteCode = {
    id: 0,
    name: '',
    expire_at: null,
    type: 1,
    number: 1,
    exchange_limit: null,
    gen_type: 1,
    extend: {
      amount: null,
      title: '',
      valid_days: 0,
      valid_start_ts: null,
      valid_end_ts: null,
      weekAmount: null,
      cashAmount: null,
      money_limit: null,
    },
  };

  private query: iPromoteQuery = {
    id: null,
    name: '',
    opr_name: '',
    pack_id: -1,
  };

  search() {
    this.page_query.page = 1;
    this.getPromoteCodeTable();
  }

  //创建
  openModal() {
    this.clear();
    this.title = '创建推广码';
    this.visible = true;
  }
  //详情
  detail(row: iPromoteCode) {
    this.visible = true;
    this.title = '推广码详情';
    this.model = row;
  }
  handlerSuccess() {
    this.visible = false;
    this.getPromoteCodeTable();
  }
  async getPromoteCodeTable() {
    try {
      this.loading = true;
      const res = await getOldPromoteCodeList({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async switchCode(row: any) {
    try {
      const res = await updateOpen({ id: row.id, open: row.open });
      if (res.code == 0) {
        toast('操作成功!');
        this.getPromoteCodeTable();
      }
    } catch (error) {
      toast(error.msg, 'warning');
      LogUtils.debug(error);
    }
  }
  clear() {
    this.model = {
      id: 0,
      name: '',
      expire_at: null,
      type: 1,
      number: 1,
      exchange_limit: null,
      gen_type: 1,
      extend: {
        amount: null,
        title: '',
        valid_days: 0,
        valid_start_ts: null,
        valid_end_ts: null,
        weekAmount: null,
        cashAmount: null,
        money_limit: null,
      },
    };
  }

  mounted() {
    this.pageFn = this.getPromoteCodeTable;
    this.getPromoteCodeTable();
  }
}
